import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';

import Tooltip from '../../../../../shared/components/Tooltip';
import AmplitudeAnalytics from '../../../../../shared/services/AmplitudeAnalytics';
import { Plan } from '../../../../../shared/helpers/constants/plans';
import rootStore from '../../../rootStore/RootStore';
import useStartFreeTrial from '../../../../../shared/features/user/hooks/useStartFreeTrial';
import CtaButton from '../../../../components/CtaButton';
import useUser from '../../../../../shared/features/user/hooks/useUser';

const CtaTooltipButton = observer(() => {
  const { t } = useTranslation();
  const { userStore, areaUnitStore } = rootStore;
  const { startFreeTrial } = useStartFreeTrial(rootStore);
  const { isCombinedDataLoaded: userDataLoaded } = useUser(rootStore);
  const { areaUnit } = areaUnitStore;
  const trialOrderPresent = userStore.hasFreeTrialOrder;
  const paidOrderPresent = userStore.hasPaidOrder;

  const handleCtaClick = () => {
    AmplitudeAnalytics.trackPlanSelect(Plan.freeTrial);

    if (userDataLoaded) {
      void startFreeTrial(areaUnit);
    }
  };

  return trialOrderPresent || paidOrderPresent ? (
    <Tooltip
      title={
        paidOrderPresent
          ? t('plans.free-trial.paid-plan-used')
          : t('plans.free-trial.trial-already-used')
      }
    >
      <Box>
        <CtaButton
          label={t('plan-select.action-button.start-free-trial')}
          disabled
          styles={{ width: 1 }}
          onClick={handleCtaClick}
        />
      </Box>
    </Tooltip>
  ) : (
    <CtaButton
      label={t('plan-select.action-button.start-free-trial')}
      to={userDataLoaded ? undefined : import.meta.env.VITE_APP_URL}
      onClick={handleCtaClick}
    />
  );
});

export default CtaTooltipButton;
